import Vue from "vue";
import Router from "vue-router";

// 路由懒加载
const Index = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Index");
const Team = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Team");
const Achievement = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Achievement");
// const Paper = () =>
//     import ( /* webpackChunkName: 'Page' */ "../views/Paper");
// const Project = () =>
//     import ( /* webpackChunkName: 'Page' */ "../views/Project");
const Details = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Details");
const NewsList = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/NewsList");
const Contact = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Contact");
const Recruit = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Recruit");
const Student = () =>
    import ( /* webpackChunkName: 'Page' */ "../views/Student");
Vue.use(Router);

const router = new Router({
    mode: "history",
    // base: "/",
    routes: [{
            path: "*",
            redirect: "/index",
        },
        {
            path: "/index",
            name: "index",
            component: Index,
            meta: { KeepAlive: true },
        },
        {
            path: "/team",
            name: "team",
            component: Team,
            meta: { KeepAlive: true },
        },
        {
            path: "/achievement",
            name: "achievement",
            component: Achievement,
            meta: { KeepAlive: true },
        },
        // {
        //     path: "/paper",
        //     name: "paper",
        //     component: Paper,
        //     meta: { KeepAlive: true },
        // },
        // {
        //     path: "/project",
        //     name: "project",
        //     component: Project,
        //     meta: { KeepAlive: true },
        // },
        {
            path: "/newsList",
            name: "newsList",
            component: NewsList,
            meta: { KeepAlive: true },
        },
        {
            path: "/student",
            name: "student",
            component: Student,
            meta: { KeepAlive: true },
        },
        {
            path: "/details",
            name: "details",
            component: Details,
            meta: { KeepAlive: false },
        },
        {
            path: "/recruit",
            name: "recruit",
            component: Recruit,
            meta: { KeepAlive: true },
        },
        {
            path: "/contact",
            name: "contact",
            component: Contact,
            meta: { KeepAlive: true },
        },
        {
            path: '*',
            redirect: '/index' // 将用户重定向到网站首页
        }
    ],
});
router.beforeEach(function(to, from, next) {
    if (to.matched.length === 0) { //如果未匹配到路由
        from.path ? next({ path: from.path }) : next('/'); //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    } else {
        next(); //如果匹配到正确跳转
    }
})
export default router;